import React from 'react';
import { useOutletContext } from 'react-router-dom';
import AccountSettings from '../AccountSettings';

/**
 * ProfileSettings - Account Settings page
 * Wraps the existing AccountSettings component
 */
const ProfileSettings = ({ onUserUpdate }) => {
  const { currentUser } = useOutletContext();

  return (
    <div>
      <AccountSettings currentUser={currentUser} onUserUpdate={onUserUpdate} embedded={false} />
    </div>
  );
};

export default ProfileSettings;

